module.exports = __webpack_public_path__ + "img/social-info-bg-1.52a0b146.svg";